import React from "react";

function DynamicField({ field, value, onChange, onFileChange, error, isMobile }) {
  const handleChange = (e) => {
    const { value: inputValue } = e.target;
    onChange(field.name, inputValue);
  };

  const handleCheckboxChange = (optionValue, checked) => {
    const current = Array.isArray(value) ? value : [];
    if (checked) {
      onChange(field.name, [...current, optionValue]);
    } else {
      onChange(field.name, current.filter((v) => v !== optionValue));
    }
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    onFileChange(field.name, files);
  };

  const renderField = () => {
    switch (field.field_type) {
      case "text":
        return (
          <input
            type="text"
            id={field.name}
            name={field.name}
            value={value || ""}
            onChange={handleChange}
            placeholder={field.placeholder || ""}
            required={field.required}
          />
        );

      case "textarea":
        return (
          <textarea
            id={field.name}
            name={field.name}
            value={value || ""}
            onChange={handleChange}
            placeholder={field.placeholder || ""}
            required={field.required}
            rows={5}
          />
        );

      case "email":
        return (
          <input
            type="email"
            id={field.name}
            name={field.name}
            value={value || ""}
            onChange={handleChange}
            placeholder={field.placeholder || ""}
            required={field.required}
          />
        );

      case "number":
        return (
          <input
            type="number"
            id={field.name}
            name={field.name}
            value={value || ""}
            onChange={handleChange}
            placeholder={field.placeholder || ""}
            required={field.required}
          />
        );

      case "date":
        return (
          <input
            type="date"
            id={field.name}
            name={field.name}
            value={value || ""}
            onChange={handleChange}
            required={field.required}
          />
        );

      case "select":
        return (
          <select
            id={field.name}
            name={field.name}
            value={value || ""}
            onChange={handleChange}
            required={field.required}
          >
            <option value="">Select an option</option>
            {field.options &&
              field.options.map((option, idx) => (
                <option key={idx} value={option.value || option}>
                  {option.label || option}
                </option>
              ))}
          </select>
        );

      case "radio":
        return (
          <div className="radioGroup">
            {field.options &&
              field.options.map((option, idx) => (
                <label key={idx} className="radioOption">
                  <input
                    type="radio"
                    name={field.name}
                    value={option.value || option}
                    checked={value === (option.value || option)}
                    onChange={handleChange}
                    required={field.required}
                  />
                  <span>{option.label || option}</span>
                </label>
              ))}
          </div>
        );

      case "checkbox":
        return (
          <div className="checkboxGroup">
            {field.options &&
              field.options.map((option, idx) => {
                const optionValue = option.value || option;
                const selected = Array.isArray(value) ? value.includes(optionValue) : false;
                return (
                  <label key={idx} className="checkboxOption">
                    <input
                      type="checkbox"
                      name={field.name}
                      value={optionValue}
                      checked={selected}
                      onChange={(e) => handleCheckboxChange(optionValue, e.target.checked)}
                    />
                    <span>{option.label || option}</span>
                  </label>
                );
              })}
          </div>
        );

      case "file":
        return (
          <input
            type="file"
            id={field.name}
            name={field.name}
            onChange={handleFileChange}
            multiple
            accept={field.accept || "*"}
          />
        );

      default:
        return (
          <input
            type="text"
            id={field.name}
            name={field.name}
            value={value || ""}
            onChange={handleChange}
            placeholder={field.placeholder || ""}
            required={field.required}
          />
        );
    }
  };

  return (
    <div className={`formField ${error ? "hasError" : ""}`}>
      <label htmlFor={field.name}>
        {field.label}
        {field.required && <span className="required">*</span>}
      </label>
      {renderField()}
      {field.help_text && <span className="helpText">{field.help_text}</span>}
      {error && <span className="fieldError">{error}</span>}
    </div>
  );
}

export default DynamicField;
